import { ChatCircleDotsIcon } from '@phosphor-icons/react'
import type { NodeProps } from '@xyflow/react'
import { useListCopy } from 'app/hooks/useListCopy'
import { labelForToken } from 'app/lib/workflows/dataContext'
import { humanizeTokens } from 'app/lib/workflows/messageFallbacks'
import type { SendSmsFlowNode } from 'app/types/workflows'
import { NodeShell } from './NodeShell'

/** Sends an SMS to the enrolled contact. */
export function SendSmsNode({ data, selected }: NodeProps<SendSmsFlowNode>) {
  const copy = useListCopy()
  // Tokens read as their labels on the card ("Hi First name, ...") — raw {{...}} syntax stays in
  // the data, never on the canvas (UX audit C3).
  const summary = data.message.trim()
    ? humanizeTokens(data.message, (token) => labelForToken(token, copy))
    : `No message yet`
  return (
    <NodeShell
      icon={ChatCircleDotsIcon}
      accent="blue"
      kind="Send SMS"
      label={data.label}
      description={summary}
      selected={selected}
    />
  )
}
